import React, { Component } from "react";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Loader,
  Img,
  Toastr,
} from "arv-reactcomponents";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import PricingOverview from "../../component/PricingOverview";
// import CheckoutMyBagButton from "../../component/CheckoutMyBagButton"
import CartProducts from "../../component/CartProducts";
import Promotions from "../../component/Promotions";
import MybagSubheader from "../../component/MybagSubheader";
import MybagEmptyState from "../../component/MybagEmptyState";
import MYbagOfferingBlock from "../../component/MybagOfferingBlock";

import {
  setPageType,
  getLocalCart,
  removedUndefinedFromObj,
  getStrippedCart,
} from "../../utils";
import {
  Checkout,
  MyBag as MYBAG,
  pageType,
  PRICINGOVERVIEW,
  MY_BAG_OFFER_IMAGE,
  ROUTE_PATHS,
} from "npmlinks-constants";
import Anchor from "../../component/Anchor";

import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";
import StickyPricingOverview from "../../component/CheckoutComponents/StickyPricingOverview";
import BreachHandler from "../../component/CheckoutComponents/BreachHandler";
import GTM from "../../analytics/GTM";

const { TEXT, TOTAL } = PRICINGOVERVIEW;

@inject("LoginStore", "CheckoutStore")
@observer
class MyBag extends Component {
  static triggerRemoveGa(product) {
    const { skuId } = product;
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.MYBAG_PRODUCT_SHORTLIST,
      label: skuId,
    });
  }
  static shopMoreClick() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.CONTINUE_SHOPPING,
    });
  }
  static triggerLandedGa() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.MYBAG_LANDED,
    });
  }
  static triggerGTMEvent(product, eventName) {
    GTM.pushWithEvent(product, eventName);
  }
  constructor() {
    super();
    this.state = {
      disableActions: false,
      loading: true,
    };
    this.shouldgotofav = false;
    this.isUserLoggedIn = false;
    this.goToCheckout = false;
    this.init = this.init.bind(this);
    this.mounted = this.mounted.bind(this);
    this.onCheckoutClick = this.onCheckoutClick.bind(this);
    this.favoriteProduct = this.favoriteProduct.bind(this);
    this.onFavClick = this.onFavClick.bind(this);
  }
  componentDidMount() {
    setPageType(pageType.myBag);
    Analytics.pageView(window.pageType);
    this.init();
    this.mounted();
    MyBag.triggerLandedGa();
  }
  mounted() {
    this.setState({ loading: false });
  }
  componentWillUpdate(nextProps) {
    const { isUserLoggedIn: newLoggedIn } = nextProps.LoginStore;
    if (newLoggedIn !== this.isUserLoggedIn) {
      this.init(newLoggedIn);
      this.onFavClick(null, newLoggedIn);
    }
  }
  onFavClick(event, isLoggedIn = false) {
    const { isUserLoggedIn } = this.props.LoginStore;
    if (isLoggedIn && this.shouldgotofav) {
      window.location.href = window.location.origin + ROUTE_PATHS.SHORTLISTS;
    } else if (!isUserLoggedIn && !isLoggedIn && event) {
      event.preventDefault();
      this.props.LoginStore.setloginModal(true);
      this.shouldgotofav = true;
    }
  }
  get validCart() {
    const { cartItems } = this.props.CheckoutStore;
    const cartProducts = cartItems.length;
    if(cartProducts > 0) {
      MyBag.triggerGTMEvent(toJS(cartItems), Event.GTMEvent.MYBAG_LANDED);
    }
    return cartProducts > 0;
  }
  get loading() {
    return this.props.CheckoutStore.loading || this.state.loading;
  }
  get allAreValidProducts() {
    const { cartItems } = this.props.CheckoutStore;
    const validItems = cartItems.filter(item => item.sellableQty > 0);
    return validItems.length > 0;
  }
  onCheckoutClick(event) {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.MYBAG_CHECKOUT_CLICK,
    });
    const { isUserLoggedIn } = this.props.LoginStore;
    if (!isUserLoggedIn) {
      event.preventDefault();
      this.goToCheckout = true;
      this.props.LoginStore.setloginModal(true);
    } else if (!this.allAreValidProducts) {
      event.preventDefault();
      Toastr.showToastr({
        className: "nwc-toastr-list-notification nw-toastr",
        message: Checkout.CHECKOUT_MESSAGES.OOS_TOASTR,
        timeout: 3000,
      });
    } else {
      this.props.CheckoutStore.triggerLoader(true);
    }
  }
  favoriteProduct() {
    const { isUserLoggedIn } = this.props.LoginStore;
    const { productToBeFavorited } = this.props.CheckoutStore;
    if (isUserLoggedIn && productToBeFavorited) {
      const { skuId } = productToBeFavorited;
      const { cartItems } = this.props.CheckoutStore;
      const [product] = cartItems.filter(item => item.skuId === skuId);
      const extraKeys =  Checkout.CHECKOUT_EXTRA_KEYS_FOR_CART.FAVORITE;
      const [productForRequest] = getStrippedCart([product], extraKeys);
      productForRequest.isFavourite = true;
      this.props.CheckoutStore.setProductToBeFavorited(null);
      const request = {
        ...Checkout.CHECKOUT_BASE_REQUEST,
        type: Checkout.CHECKOUT_API_ACTIONS.DELETE,
        removeCart: [productForRequest],
      };
      this.props.CheckoutStore.updateCart(request, isUserLoggedIn).then(() => {
        MyBag.triggerRemoveGa(product);
        Toastr.showToastr({
          className: "nwc-toastr-list-success nw-toastr",
          message: Checkout.CHECKOUT_MESSAGES.PRODUCT.FAVORITE,
          timeout: 3000,
        });
      });
    }
  }
  init(newLoggedIn = false) {
    const { isUserLoggedIn } = this.props.LoginStore;
    const isLoggedIn = isUserLoggedIn || newLoggedIn;
    this.isUserLoggedIn = isLoggedIn;
    const localCart = getLocalCart();
    if (!isLoggedIn && localCart.length === 0) {
      this.props.CheckoutStore.clearCart();
      return null;
    }
    this.props.CheckoutStore.updateCart({}, isLoggedIn).then(() => {
      this.favoriteProduct();
      if (this.goToCheckout) {
        this.props.history.push(Checkout.CHECKOUT_ROUTES.DEFAULT);
      }
    });
    return null;
  }
  get pricingOverview() {
    const {
      subtotal,
      discounts,
      tax,
      shippingCost,
      total,
    } = this.props.CheckoutStore.pricingOverviewData;
    return removedUndefinedFromObj({
      [TEXT.subtotal]: subtotal,
      [TEXT.discounts]: discounts,
      [TEXT.tax]: tax,
      [TEXT.shippingCost]: shippingCost,
      [TOTAL.total]: total,
    });
  }

  render() {
    let mybagBody = null;
    const { disableActions } = this.state;
    const { isUserLoggedIn } = this.props.LoginStore;
    const { bagTotalItemCount, pricingOverviewData } = this.props.CheckoutStore;
    const offerImage = MY_BAG_OFFER_IMAGE.imageLink;
    if (this.validCart) {
      mybagBody = (
        <GridRow>
          {offerImage && (
            <GridColumn className="nwc-grid-col-sm-12 nw-mobile-only">
              <Anchor.component
                target="_self"
                to={MY_BAG_OFFER_IMAGE.link}
                href={MY_BAG_OFFER_IMAGE.link}
                className="nw-mybag-offerlink"
              >
                <Img
                  className="nw-mybag-offerimage"
                  src={offerImage}
                  alt={MYBAG.MYBAGPAGE.ALT_IMG_TEXT}
                />
              </Anchor.component>
            </GridColumn>
          )}
          <GridColumn className="nwc-grid-col-sm-8 nw-mybagpage-leftcol">
            <CartProducts.component />
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-12 nw-mobile-only">
            <Anchor.component
              target="_self"
              to="/products"
              href="/products"
              className="nwc-btn nwc-btn-normal nw-checkoutmybag-shopmore-button"
              onClick={MYBAG.shopMoreClick}
            >
              {MYBAG.MYBAGPAGE.SHOPMORE_BUTTON}
            </Anchor.component>
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-4">
            <GridRow>
              <GridColumn className="nwc-grid-col-sm-12 nw-mybag-promo-btn-col">
                <Promotions.component />
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-12">
                <PricingOverview.component
                  pricingOverviewData={this.pricingOverview}
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-12">
                <div className="nwc-mobile-bottom-sticky nw-checkout-buttoncontainer">
                  <StickyPricingOverview.component
                    overview={pricingOverviewData}
                  />
                  <Anchor.component
                    to={Checkout.CHECKOUT_ROUTES.DEFAULT}
                    href={Checkout.CHECKOUT_ROUTES.DEFAULT}
                    onClick={this.onCheckoutClick}
                    className="nwc-btn nwc-btn-primary nwc-btn-sm nw-checkoutmybag-continue-button"
                  >
                    {MYBAG.MYBAGPAGE.CHECKOUT_BUTTON}
                  </Anchor.component>
                </div>
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-12 nw-desktop-only ">
                <div className="nw-checkoutmybag-shopmorecontainer">
                  <Anchor.component
                    target="_self"
                    to="/products"
                    href="/products"
                    className="nwc-btn nwc-btn-normal nw-checkoutmybag-shopmore-button"
                    onClick={MYBAG.shopMoreClick}
                  >
                    {MYBAG.MYBAGPAGE.SHOPMORE_BUTTON}
                  </Anchor.component>
                </div>
              </GridColumn>
              {offerImage && (
                <GridColumn className="nwc-grid-col-sm-12 nw-desktop-only">
                  <Anchor.component
                    target="_self"
                    to={MY_BAG_OFFER_IMAGE.link}
                    href={MY_BAG_OFFER_IMAGE.link}
                    className="nw-mybag-offerlink"
                  >
                    <Img
                      className="nw-mybag-offerimage"
                      src={offerImage}
                      alt={MYBAG.MYBAGPAGE.ALT_IMG_TEXT}
                    />
                  </Anchor.component>
                </GridColumn>
              )}
            </GridRow>
          </GridColumn>
        </GridRow>
      );
    } else if (!this.validCart && !this.loading) {
      mybagBody = <MybagEmptyState.component onFavClick={this.onFavClick} />;
    }

    return (
      <div className="nw-mybagpage">
        {(this.loading || disableActions) && (
          <div className="nw-mybagpage-initialloader nwc-translucentbackground-white">
            <Loader />
          </div>
        )}
        <div className="nw-mybagpage-wrapper">
          <MybagSubheader.component
            isUserLoggedIn={isUserLoggedIn}
            bagTotalItemCount={bagTotalItemCount}
          />
          <GridContainer className="nw-mybagpage-view">
            <BreachHandler.component />
            {mybagBody}
            {this.validCart && <MYbagOfferingBlock.component />}
          </GridContainer>
        </div>
      </div>
    );
  }
}

MyBag.wrappedComponent.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  LoginStore: PropTypes.shape({
    isUserLoggedIn: PropTypes.bool.isRequired,
    setloginModal: PropTypes.func.isRequired,
  }).isRequired,
  CheckoutStore: PropTypes.shape({
    setProductToBeFavorited: PropTypes.func.isRequired,
    productToBeFavorited: PropTypes.string,
    clearCart: PropTypes.func.isRequired,
    pricingOverviewData: PropTypes.shape({
      subtotal: PropTypes.number.isRequired,
      discounts: PropTypes.number.isRequired,
      tax: PropTypes.number.isRequired,
      shippingCost: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }).isRequired,
    bagTotalItemCount: PropTypes.number.isRequired,
    cartItems: PropTypes.shape({}).isRequired,
    setCartItems: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    updateCart: PropTypes.func.isRequired,
    triggerLoader: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("LoginStore", "CheckoutStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: MyBag.wrappedComponent,
  component: MyBag,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/MyBag/index.js